import { render, staticRenderFns } from "./PlacePurchaseOrderDialog.vue?vue&type=template&id=5e5bc190&"
import script from "./PlacePurchaseOrderDialog.vue?vue&type=script&lang=js&"
export * from "./PlacePurchaseOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports